import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '~env';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private httpClient = inject(HttpClient);

  login(username: string, password: string) {
    return this.httpClient.post<{ token: string }>(
      environment.apiBasePaths.general + '/auth/login_check',
      {
        username,
        password,
      }
    );
  }
}
